/* eslint-disable @typescript-eslint/naming-convention */
import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

import { Input as OriginalInput } from '@change-corgi/design-system-legacy/components/forms';

type Props = React.ComponentProps<typeof OriginalInput> & {
	isSunriseEnabled: boolean;
};

// eslint-disable-next-line react/display-name
export const Input = forwardRef(
	({ isSunriseEnabled, ...props }: Props, ref: ForwardedRef<HTMLInputElement>): JSX.Element => {
		const containerSx = {
			'& label span': {
				fontSize: 12,
				fontWeight: 'bold',
				color: 'sunrise.semantic.typography.strong',
			},

			'& [id$=___error] > span': {
				marginLeft: '-4px',
				color: 'sunrise.semantic.typography.error',
			},

			'& [id$=___error] span svg': {
				marginRight: '4px',
				color: 'sunrise.semantic.icon.error',
			},
			input: {
				borderColor: 'sunrise.semantic.stroke.weaker',
				borderWidth: 1,
				borderStyle: 'solid',

				'&:hover, &:active, &:focus': {
					borderColor: 'sunrise.semantic.stroke.accent.primary.strong',
					boxShadow: 'none',
				},

				'&:active, &:focus': {
					borderWidth: 2,
				},

				'&[data-error=true]': {
					borderWidth: 2,
					borderStyle: 'solid',
					borderColor: 'sunrise.semantic.stroke.error.strong',
					boxShadow: 'none',
				},
			},
		};

		return (
			<>
				{isSunriseEnabled ? (
					<div data-qa="input-wrapper-container" sx={containerSx}>
						<OriginalInput {...props} ref={ref} />
					</div>
				) : (
					<OriginalInput {...props} ref={ref} />
				)}
			</>
		);
	},
);
